import { createApp } from 'vue';

// Import components
import ProductListing from './components/product-listing.vue';
import ProductCompare from './components/product-compare.vue';
import Svg from './components/svg.vue';
import GenericListing from './components/generic-listing.vue';
import DocumentListing from './components/document-listing.vue';
import ProTipListing from './components/pro-tip-listing.vue';
import BusinessResourceListing from './components/business-resource-listing.vue';
import ProTipUnfilteredListing from './components/pro-tip-unfiltered-listing.vue';
import MemberListing from './components/member-listing.vue';
import { BootstrapIconsPlugin } from 'bootstrap-icons-vue';

/**
 * Creates a Vue instance for each element matching the selector.
 * @param {string} selector - CSS selector
 * @param {Object} options - Vue instance options
 * @param {function} setup - Optional setup function to execute on Vue instance
 */
function createVueInstance(selector, options, setup) {
  const elements = Array.from(document.querySelectorAll(selector))
  elements.forEach(element => {
    const app = createApp(options)
    app.config.globalProperties.window = window

    if (setup) {
      setup(app, element)
    }

    app.mount(element)
  });
}

// Initialize application
createApp({
  components: {
    'product-listing': ProductListing,
    'icon': Svg
  }
}).mount('#product-listing-vue');

createApp({
  components: {
    'product-compare': ProductCompare,
    'icon': Svg
  }
}).mount('#product-compare-vue')

createApp({
  components: {
    'generic-listing': GenericListing,
    'icon': Svg
  }
}).mount('.generic-listing-vue');

createApp({
  components: {
    'document-listing': DocumentListing,
    'icon': Svg
  }
}).use(BootstrapIconsPlugin).mount('.document-listing-vue');

function pickMemberListing(app, element) {
  window.wf ??= {};
  window.wf.memberListings ??= [];

  window.wf.memberListing = window.wf.memberListings.find(ml => ml.id == element.id);
}

createVueInstance(
  '#pro-tip-unfiltered-listing-vue',
  {
    components: {
      'pro-tip-unfiltered-listing': ProTipUnfilteredListing,
      'icon': Svg
    }
  }
);

createVueInstance(
  '#pro-tip-listing-vue',
  {
    components: {
      'pro-tip-listing': ProTipListing,
      'icon': Svg
    }
  }
);

createVueInstance(
  '.member-listing-vue',
  {
    components: {
      'member-listing': MemberListing,
      'icon': Svg
    }
  },
  pickMemberListing
);

createVueInstance(
  '#business-resource-listing-vue',
  {
    components: {
      'business-resource-listing': BusinessResourceListing,
      'icon': Svg
    }
  }
);
